import { useAppSelector } from '@/hooks/use-app-selector'
import { IMultiLevelMenu } from '@interfaces/interfaces'
import React from 'react'
import { Navigation } from '../Base/Navigation/Navigation'

export const GFPADashboardNavigation: React.FC = () => {
  const reportId = useAppSelector((s) => s.axiomReport.selectedReport.reportId)
  const PortfolioOverviewMenu: IMultiLevelMenu = {
    isDownArrow: false,
    heading: 'Attribution Overview',
    isMenuList: false,
    route: `/reports/${reportId}/gfpa/dashboard`,
  }
  const PortfolioDetailsMenu: IMultiLevelMenu = {
    isDownArrow: false,
    heading: 'Daily Attribution',
    isMenuList: false,
    route: `/reports/${reportId}/gfpa/daily-attribution`,
  }
  const SecurityDetailsMenu: IMultiLevelMenu = {
    isDownArrow: false,
    heading: 'Security Details',
    isMenuList: false,
    route: `/reports/${reportId}/gfpa/detail`,
  }

  const headerMenuItems: IMultiLevelMenu[] = [
    PortfolioOverviewMenu,
    PortfolioDetailsMenu,
    SecurityDetailsMenu,
  ]
  return (
    <Navigation
      headerMenuItems={headerMenuItems}
      highlightActive={true}
      paddingHorizontal={0}
    />
  )
}
